import _ from 'lodash';

export default class RoamingRCC {
  constructor(data) {
    const defaults = {
      used: 0,
      limit: 0,
      notifyLimit: 0,
      fupCurrent: 0,
      fupLimit: 0,
    };
    data = _.merge(defaults, data);
    this.used = data.used;
    this.limit = data.limit;
    this.notifyLimit = data.notifyLimit;
    this.fupCurrent = data.fupCurrent;
    this.fupLimit = data.fupLimit;
  }
}
